import { ApiReportSuggestionGenerationStatusChoices } from "@api/graphql/types-and-hooks";
import { useReviewData } from "@components/QaReview/hooks/useReviewData";

const { Completed, Failure } = ApiReportSuggestionGenerationStatusChoices;

export type QaScanState = {
  /** Starting or running. */
  isRunning: boolean;
  /** Running, or its status or flags are still loading (QA items only load once the scan has completed). */
  isChecking: boolean;
  isFailed: boolean;
};

/** Where the Quality Review scan stands, shared by the Checkpoint switch, the view picker and the review bar. */
export const useQaScanState = (): QaScanState => {
  const { status, isQaPending, isInProgress, isStarting, isStatusLoading } = useReviewData();
  const isRunning = isInProgress || isStarting;
  return {
    isRunning,
    isChecking: isRunning || isStatusLoading || (status === Completed && isQaPending),
    isFailed: !isRunning && status === Failure,
  };
};
